import styled from 'styled-components';

const TabButton = styled.div`
	position: relative;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 0;
	border-radius: 6px;
	background-color: #fff;
	user-select: none;

	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background: linear-gradient(360deg, #eeeeee 0%, #b2b2b2 100%);
`;

export { TabButton };
